import { Controller } from 'react-hook-form'
import { toast } from 'sonner'

import { Button } from '../ui/button'
import { Form } from '../ui/form'
import { FieldWrapper } from '../ui/form/field-wrapper'
import { Input } from '../ui/form/input'

import { CreatePatientInput, createPatientInputSchema, useCreatePatient } from '@/features/patients/api/create-patient'
import { GenderSelect } from '@/features/patients/components/patient-gender-select'
import { logger } from '@/logger'
import { CreatePatientModal, ModalRenderArgs } from '@/state/modals'

function CreatePatientModalContent({ modal, slots, ctx }: ModalRenderArgs<CreatePatientModal>) {
  const { Header, Body, Footer, Title, Description } = slots

  const createPatientMutation = useCreatePatient({
    mutationConfig: {
      onSuccess: () => {
        toast.success('Fiche patient créée')
        ctx.resolve()
      },
      onError: (error) => {
        if ('code' in error && error.code === '23505') {
          toast.error('Fiche déjà existante pour ce patient')
        } else {
          toast.error('Erreur lors de la création de la fiche patient')
        }
        logger.error('Error creating patient', { error })
      },
    },
  })

  return (
    <>
      <Header className="space-y-2">
        <Title>Créer une fiche patient</Title>
        <Description>Renseignez les informations principales du patient.</Description>
      </Header>

      <Body>
        <Form
          id="create-patient"
          schema={createPatientInputSchema}
          onSubmit={(data) => createPatientMutation.mutate({ data })}
          options={{ defaultValues: { pid: modal.pid } as CreatePatientInput }}
        >
          {({ register, formState, control }) => (
            <div className="grid gap-3">
              <Input
                name="name"
                type="text"
                registration={register('name')}
                label="Nom"
                error={formState.errors['name']}
              />
              <Input
                name="age"
                type="number"
                min={1}
                max={150}
                registration={register('age')}
                label="Age"
                error={formState.errors['age']}
              />

              <FieldWrapper label="Genre">
                <Controller
                  name="gender"
                  control={control}
                  render={({ field }) => <GenderSelect value={field.value} onValueChange={field.onChange} />}
                />
              </FieldWrapper>
            </div>
          )}
        </Form>
      </Body>

      <Footer className="flex justify-end gap-2 border-t pt-4">
        <Button type="button" variant="outline" onClick={() => ctx.close()}>
          Annuler
        </Button>
        <Button
          className="w-full sm:w-1/2 md:w-[initial]"
          form="create-patient"
          type="submit"
          isLoading={createPatientMutation.isPending}
          disabled={createPatientMutation.isPending}
        >
          Créer
        </Button>
      </Footer>
    </>
  )
}

export function render(args: ModalRenderArgs<CreatePatientModal>) {
  return <CreatePatientModalContent {...args} />
}
